import React from 'react';
import Button from '../../common/Button';

export default class EditorSnapshotLoadErrorAlert extends React.Component {
    render() {
        return (
            <div className="configuration-editor-connection-lost-alert">
                <div>
                    {__('Snapshot could not be loaded - version mismatch.')}<br/>
                    {__('Default settings will be used.')}<br/><br/>

                    <Button theme={Button.Theme.BorderOnly} color={Button.Color.White}
                            onClick={this.props.onCloseClick}>{__('Close')}</Button>
                </div>
            </div>
        )
    }
}